import { useAtomValue, useSetAtom } from 'jotai';

import { Divider, Stack } from '@ekhodealer/ekho-common/rev';

import type { ReactNode } from 'react';

import { FiltersDrawer } from '@common/components/FiltersDrawer';

import { useSearchOrders } from '../api/useSearchOrders';
import { allAppliedFiltersAtom } from '../atoms/ordersAppliedFiltersAtoms';
import { clearAllFiltersAtom, ordersParamsAtom } from '../atoms/ordersAtoms';

import {
	FiltersDrawerActionRequiredSection,
	FiltersDrawerFulfillmentSection,
	FiltersDrawerOrderDateSection,
	FiltersDrawerOrderStatusSection,
	FiltersDrawerRegistrationSection,
	FiltersDrawerVehicleInformationSection,
	OrdersFiltersDrawerAppliedFiltersSection,
} from './filters';

interface OrdersFiltersDrawerProps {
	trigger: ReactNode;
}

export const OrdersFiltersDrawer = ({ trigger }: OrdersFiltersDrawerProps) => {
	const allAppliedFilters = useAtomValue(allAppliedFiltersAtom);
	const clearAllFilters = useSetAtom(clearAllFiltersAtom);
	const hasAppliedFilters = allAppliedFilters.length > 0;

	const params = useAtomValue(ordersParamsAtom);
	const { data, isLoading } = useSearchOrders(params);
	const queryCount = data?.count ?? 0;

	return (
		<FiltersDrawer
			trigger={trigger}
			appliedFiltersSection={<OrdersFiltersDrawerAppliedFiltersSection />}
			filterSections={
				<>
					<FiltersDrawerActionRequiredSection />
					<Stack>
						<Divider />
						<FiltersDrawerOrderDateSection />
						<Divider />
						<FiltersDrawerOrderStatusSection />
						<Divider />
						<FiltersDrawerVehicleInformationSection />
						<Divider />
						<FiltersDrawerRegistrationSection />
						<Divider />
						<FiltersDrawerFulfillmentSection />
					</Stack>
				</>
			}
			hasAppliedFilters={hasAppliedFilters}
			clearAllFilters={clearAllFilters}
			queryCount={queryCount}
			isLoading={isLoading}
			className='filters-drawer--custom'
		/>
	);
};
